import React, { useEffect } from 'react';
import { AppContext } from '../../App';
import './homepage.css';

const Homepage = () => {
  const { addListeners } = React.useContext(AppContext);
  useEffect(() => {
    addListeners();
  }, []);

  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <section id="hero" className="d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
              <h1>Elegant, creative, and intelligent engineering solutions</h1>
              <h2>
                We are a team of industrial and research professionals in the
                fields of mechanical and electrical engineering
              </h2>
              <div className="d-flex">
                <a
                  href="https://www.youtube.com/watch?v=w5Cm10tJkYA"
                  className="glightbox btn-watch-video"
                >
                  <i className="bi bi-play-circle"></i>
                  <span>Watch Video</span>
                </a>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2 hero-img p-5">
              <img
                src="assets/img/Final_Design_Assem.jpg"
                className="img-fluid animated"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section id="featured-services" className="featured-services">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bi bi-robot"></i>
                  </div>
                  <h4 className="title">
                    <a>Product design</a>
                  </h4>
                  <p className="description">
                    Our team has the expertise to transform your idea into a
                    commercial product from scratch. With extensive experience
                    in various fields of engineering, we specialize in the
                    design and control of CNC machines. Over the years, we have
                    successfully created more than 50 products for a diverse
                    range of industrial companies across the globe. Start your
                    product development with our skilled team of engineers and
                    designers.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-4 mt-md-0">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bi bi-cpu-fill"></i>
                  </div>
                  <h4 className="title">
                    <a>Electronic design</a>
                  </h4>
                  <p className="description">
                    Our company offers electronic circuit design and simulation
                    services for various types of devices, such as analog,
                    digital, embedded, and communication devices. We can also
                    provide PCB design, production (for both serial and
                    prototype production), and assembly of electronic boards.
                    Our team is equipped to handle all aspects of electronic
                    design and production to help you bring your product to
                    market.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
                <div className="icon-box">
                  <div className="icon">
                    <i className="bi bi-gear"></i>
                  </div>
                  <h4 className="title">
                    <a>Mechanical design</a>
                  </h4>
                  <p className="description">
                    We specialize in providing industrial product design and
                    design for manufacturing services for various parts,
                    products, and systems, with a particular focus on machine
                    design for different types of CNC machines. We can create
                    all the necessary technical drawings, documentation, and
                    reports to support your project. In addition, we offer
                    reverse engineering services as well as CNC machining and 3D
                    printing solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br />
        <br />
        <br />
      </main>
    </>
  );
};

export default Homepage;
